// src/lib/summaryQuery.ts
//
// Query of GET /analytics/arrivals (Resumen). `compare` is always sent: the
// endpoint compares when the parameter is missing, so an unticked «Comparar con
// el periodo anterior» has to say false.
export interface SummaryQueryParams {
  hotelIds?: string;
  hotelId?: string;
  groupId?: string;
  from?: string;
  to?: string;
  compare?: boolean;
  byHotel?: boolean;
}

export const buildSummaryQuery = (params: SummaryQueryParams): Record<string, string | boolean> => {
  const query: Record<string, string | boolean> = {};
  if (params.hotelIds) query.hotelIds = params.hotelIds;
  if (params.hotelId) query.hotelId = params.hotelId;
  if (params.groupId) query.groupId = params.groupId;
  if (params.from) query.from = params.from;
  if (params.to) query.to = params.to;
  query.compare = params.compare === true;
  if (params.byHotel) query.byHotel = true;
  return query;
};
